import { render, staticRenderFns } from "./SectionDetails.vue?vue&type=template&id=f98581a2&scoped=true"
import script from "./SectionDetails.vue?vue&type=script&lang=ts"
export * from "./SectionDetails.vue?vue&type=script&lang=ts"
import style0 from "./SectionDetails.vue?vue&type=style&index=0&id=f98581a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98581a2",
  null
  
)

export default component.exports